import axios from 'axios'
import queryString from 'query-string'
import { createGetApiCall, createPostApiCall } from '../../../Helpers/api'
import { SCOPE_TYPE } from './mediaPlayer.constants'

export const RECORDINGS_URL = '/api/rest/recording/contact'
export const STORAGE_FILE_SUFFIX = 'storagefile/status'
export const STORAGE_FILE_RESTORE = 'storagefile/request'
export const mediaPlayerRoleRoute = '/api/rest/ui/prefs/mediaPlayerRole'
export const ARCHIVE_AUDIT_URL = '/api/rest/recording/archiveaudit'
export const AUDIO_PLAYED_AUDIT_URL = '/api/rest/cas/audit/audioplayed'
export const TEXT_VIEWED_AUDIT_URL = '/api/rest/cas/audit/textviewed'
export const TenantLicensedFeatures = '/api/rest/org/tenant/features'

export const getUpdateContactURL = id => `${RECORDINGS_URL}/${id}`
export const getUpdateContactGoalURL = (contactId, goalId) => `${RECORDINGS_URL}/${contactId}/goal/${goalId}`

export default {
  async getContact(contactId, { scopeType = SCOPE_TYPE.CCR, goalId = null }) {
    const parameters = {
      expand: ['eventCalculations', 'metadata'],
      isRootRecording: scopeType === SCOPE_TYPE.ROOT,
    }
    if (goalId !== null) {
      parameters.appName = 'goalApp'
      parameters.goalId = goalId // this will populate the specific 'goal' property by id in the response
    }
    try {
      const { data } = await axios.get(`${RECORDINGS_URL}/${contactId}?${queryString.stringify(parameters)}`)
      return data
    } catch (error) {
      throw new Error(error.response ? error.response.data.errorMessage : error.message)
    }
  },

  async updateContact(contact) {
    try {
      await axios.put(getUpdateContactURL(contact.id), contact)
    } catch (error) {
      throw new Error(error)
    }
  },

  async updateReviewGoal(contactId, goalId, payload) {
    try {
      await axios.put(getUpdateContactGoalURL(contactId, goalId), payload)
    } catch (error) {
      throw new Error(error)
    }
  },

  async getStorageFile(contactId, isRootRecording) {
    try {
      const response = await axios.get(`${RECORDINGS_URL}/${contactId}/${STORAGE_FILE_SUFFIX}`, {
        params: { isRootRecording },
      })
      return response.data
    } catch (error) {
      throw new Error(error)
    }
  },

  async restoreStorageFiles(contactId, payload) {
    try {
      const response = await axios.post(`${RECORDINGS_URL}/${contactId}/${STORAGE_FILE_RESTORE}`, payload)
      return response.data
    } catch (error) {
      throw new Error(error)
    }
  },

  async saveArchiveAudit(contactId, isRootRecording, timezone) {
    try {
      await axios.post(`${ARCHIVE_AUDIT_URL}`, { contact: contactId, isRootRecording, tz: timezone })
    } catch (error) {
      throw new Error(error)
    }
  },

  async saveAudioPlayedAudit(crid, isRootRecording) {
    try {
      await axios.get(`${AUDIO_PLAYED_AUDIT_URL}`, { params: { crid, isRootRecording } })
    } catch (error) {
      throw new Error(error)
    }
  },

  async saveTextViewedAudit(ccrid) {
    try {
      await axios.get(`${TEXT_VIEWED_AUDIT_URL}`, { params: { ccrid } })
    } catch (error) {
      throw new Error(error)
    }
  },

  async getTenantLicensedFeatures() {
    try {
      const response = await axios.get(TenantLicensedFeatures)
      return response.data ? response.data.tenantFeatures : []
    } catch (error) {
      throw new Error(error)
    }
  },

  getRole: createGetApiCall(mediaPlayerRoleRoute),
  saveRole: createPostApiCall(mediaPlayerRoleRoute),
}
